import { render, staticRenderFns } from "./dialog.resource.vue?vue&type=template&id=a6747622&"
import script from "./dialog.resource.vue?vue&type=script&lang=js&"
export * from "./dialog.resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports